import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType } from 'vue'
import { NotificationData } from '../types'
import useNotifications from '../composables/useNotifications'


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationWrapper',
  props: {
  notification: {
    type: Object as PropType<NotificationData>,
    required: true
  }
},
  setup(__props) {

const props = __props;

const { pauseDeactivation, resumeDeactivation } = useNotifications()



const handleMouseEnter = () => {
  pauseDeactivation(props.notification.id)
}

const handleMouseLeave = () => {
  resumeDeactivation(props.notification.id)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    "enter-active-class": "ease-out duration-300",
    "enter-class": "opacity-0",
    "enter-to-class": "opacity-100",
    "leave-active-class": "ease-in duration-200",
    "leave-class": "opacity-100",
    "leave-to-class": "opacity-0"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        onMouseenter: handleMouseEnter,
        onMouseleave: handleMouseLeave
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 32)
    ]),
    _: 3
  }))
}
}

})